import { type LiveChannelCategory } from '@setplex/tria-api'

/* Used also as `sortOrder` value */
export enum CategoryType {
  Favorite = -2,
  All = -1,
  Regular = 0,
}

export type TvCategoryEx = Omit<LiveChannelCategory, 'id'> & {
  id: CategoryId | number
  type: CategoryType
}

export enum CategoryId {
  Favorite = 'my-list',
  All = 'all',
  Regular = NaN, // real category id is used instead
}

export enum CategoryTitle {
  Favorite = 'My List',
  All = 'All',
}

export const allCategory = {
  id: CategoryId.All,
  sortOrder: CategoryType.All,
  title: CategoryTitle.All,
  type: CategoryType.All,
}

export const favoriteCategory = {
  id: CategoryId.Favorite,
  sortOrder: CategoryType.Favorite,
  title: CategoryTitle.Favorite,
  type: CategoryType.Favorite,
}
